import React, { useEffect, useRef, useState } from 'react';
import { Palette, ChevronDown, Check } from 'lucide-react';

// Sonuç gösterim tasarımını seçmek için sade açılır menü (popover).
// Ana ekranı bozmadan, sağa yaslı küçük bir tetik buton olarak durur.
const SunDesignPicker = ({ designs, activeId, onChange }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const active = designs.find((d) => d.id === activeId) || designs[0];

  useEffect(() => {
    if (!open) return undefined;
    const handleClickOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    const handleKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKey);
    };
  }, [open]);

  return (
    <div className="relative" ref={rootRef}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm font-medium text-slate-600 shadow-sm transition-colors hover:border-amber-300 hover:text-amber-700"
      >
        <Palette className="h-4 w-4 text-amber-500" />
        <span>Görünüm: <b className="text-slate-800">{active.name}</b></span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div
          role="listbox"
          className="absolute bottom-full right-0 z-30 mb-2 w-64 overflow-hidden rounded-xl border border-slate-200 bg-white py-1.5 shadow-xl"
        >
          {designs.map((d) => {
            const selected = d.id === activeId;
            return (
              <button
                key={d.id}
                type="button"
                role="option"
                aria-selected={selected}
                onClick={() => { onChange(d.id); setOpen(false); }}
                className={`flex w-full items-start gap-2 px-3 py-2 text-left transition-colors hover:bg-slate-50 ${selected ? 'bg-amber-50/60' : ''}`}
              >
                <Check className={`mt-0.5 h-4 w-4 flex-none ${selected ? 'text-amber-600' : 'text-transparent'}`} />
                <span className="min-w-0">
                  <span className="block text-sm font-medium text-slate-800">{d.name}</span>
                  <span className="block truncate text-xs text-slate-400">{d.tag}</span>
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SunDesignPicker;
